<template>
    <div class="row payment-tab">
        <div class="col-12 col-md-6">
            <section id="subscription-condition-management">
                <subscription-payment-management
                    :subscription-data="subscriptionData"
                ></subscription-payment-management>
            </section>
        </div>
<!--        TODO: implement when ready-->

<!--        <f-col-->
<!--            cols="12"-->
<!--            sm="12"-->
<!--            md="7"-->
<!--            lg="7"-->
<!--            xl="7"-->
<!--        >-->
<!--            <subscription-payment-history></subscription-payment-history>-->
<!--        </f-col>-->
    </div>
</template>

<script>
import SubscriptionPaymentManagement from "../molecules/SubscriptionPaymentManagement.vue";
import SubscriptionPaymentHistory from "../molecules/SubscriptionPaymentHistory.vue";

export default {
    name: 'CdbTabPayment',
    components: {
        SubscriptionPaymentHistory,
        SubscriptionPaymentManagement,
    },

    props: {
        subscriptionData: null
    },
}
</script>
